import { NotificationManager } from 'react-notifications';
import { Actions as COMPANYACTIONS } from "../../../../store/actions/companyActions";

import apiURL from'../../../../store/actions/apiURL';

const Types = {
    FYORIN_UPDATE_CONNECTION: "FYORIN_UPDATE_CONNECTION",
    FYORIN_UPDATE_EMPLOYEE: "FYORIN_UPDATE_EMPLOYEE",
    FYORIN_UNSYNCED_EMPLOYEE: "FYORIN_UNSYNCED_EMPLOYEE",
    FYORIN_PAYMENT_STAGE: "FYORIN_PAYMENT_STAGE",
    FYORIN_SYNCING_STATUS: "FYORIN_SYNCING_STATUS",
    FYORIN_PAY_PERIOD: "FYORIN_PAY_PERIOD"
};

const updateEmployeeState = (data) => ({
    type: Types.FYORIN_UPDATE_EMPLOYEE,
    fyorinId: data.fyorinId,
    pending: data.pending
})
const updateSyncingState = (data) => ({
    type: Types.FYORIN_SYNCING_STATUS,
    unsyncedEmployees: data.unsyncedEmployees,
    error: data.error,
    syncingStatus: data.syncingStatus
})
const setPaymentStage = (stage) => ({
    type: Types.FYORIN_PAYMENT_STAGE,
    stage
})
const updatePayPeriod = (payPeriodId, response) => ({
    type: Types.FYORIN_PAY_PERIOD,
    payPeriodId,
    fyorinId: response.fyorinId,
    fyorinStatus: response.fyorinStatus
})

const connectFyorin = () => {
    return (dispatch, getState) => {

        fetch(apiURL + `/integrations/fyorin/connect`, {
            credentials: 'include',
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        })
            .then(response => response.json())
            .then(data => {
                window.open(data.url, '_blank')
                dispatch(COMPANYACTIONS.getCompanySettings())
            })
            .catch((error) => {
                console.error(error)
                NotificationManager.error('Error Connecting Fyorin', 'Connect Fyorin')
            })
    }
}

const verifyConnection = () => {
    return (dispatch, getState) => {

        fetch(apiURL + `/integrations/fyorin/verify-connected`, {
            credentials: 'include',
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        })
            .then(response => response.json())
            .then(data => {
                if (data.url) {
                    window.open(data.url, '_blank')
                }
                dispatch(COMPANYACTIONS.getCompanySettings())
            })
            .catch((error) => {
                console.error(error)
                NotificationManager.error('Error Veryifing Connection With Fyorin', 'Connect Fyorin')
            })
    }
}

const disconnectFyorin = () => {
    return (dispatch, getState) => {

        fetch(apiURL + `/integrations/fyorin/revoke`, {
            credentials: 'include',
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        })
            .then(response => response.json())
            .then(() => {
                dispatch(COMPANYACTIONS.getCompanySettings())
            })
            .catch((error) => {
                console.error(error)
                NotificationManager.error('Error Disconnecting Fyorin', 'Disconnect Fyorin')
            })
    }
}

const updateEmployeeRequest = (agreement) => {
    return new Promise(async (resolve, reject) => {
        fetch(apiURL + `/integrations/fyorin/update-employee`, {
            credentials: 'include',
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                agreement
            })
        })
            .then((response) => {
                if(response.status != 200) {
                    reject()
                } else {
                    resolve(response)
                }
            })
            .catch((error) => {
                reject(error)
            })
    })
}

const updateFyorinEmployee = (agreement) => {
    return (dispatch, getState) => {

        updateEmployeeRequest(agreement)
            .then(response => response.json())
            .then(data => {
                dispatch(updateEmployeeState(data))
            })
            .catch((error) => {
                console.error(error)
                dispatch(updateEmployeeState({ pending: true }))
                NotificationManager.error('Error Updating Employee On Fyorin', 'Fyorin Update Employee')
            })
    }
}

const getEmployeesToSync = (payPeriodId) => {
    return (dispatch, getState) => {

        fetch(apiURL + `/integrations/fyorin/resync/${payPeriodId}/employees`, {
            credentials: 'include',
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        })
            .then(response => response.json())
            .then(data => {
                dispatch(updateSyncingState(data))
            })
            .catch((error) => {
                console.error(error)
                dispatch(updateSyncingState({ error: true }))
                NotificationManager.error('Error Getting Employees', 'Fyorin Sync Employees')
            })
    }
}

const getPayrollUpdate = (payPeriodId) => {
    return async (dispatch, getState) => {
        fetch(apiURL + `/integrations/fyorin/resync/${payPeriodId}/pay-period`, {
            credentials: 'include',
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        })
            .then(response => response.json())
            .then(response => {
                dispatch(updatePayPeriod(payPeriodId, response))
            })
            .catch((error) => {
                console.error(error)
                NotificationManager.error('Error Getting Updated Fyorin Status', 'Fyorin Payroll Status')
            })
    }
}

const sendPayrollToFyorin = (payPeriodId, transferDate) => {
    return async (dispatch, getState) => {
        let state = getState()

        if (state?.integration?.payment?.fyorin?.syncError) {
            NotificationManager.error('Failed to Sync All Employees', 'Fyorin Sync Employees')
            dispatch(setPaymentStage('Error'))
        } else {
            if (state?.integration?.payment?.fyorin?.unsyncedEmployees?.length > 0) {
                NotificationManager.success('Successfully Synced All Employees', 'Fyorin Sync Employees')
            }

            dispatch(setPaymentStage('Sending'))

            // await new Promise((resolve, reject) => {
            //     setTimeout(() => { resolve() }, 5000);
            // })
            fetch(apiURL + `/integrations/fyorin/send-payments`, {
                credentials: 'include',
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    payPeriodId,
                    transferDate
                })
            })
                .then(response => response.json())
                .then(response => {
                    dispatch(setPaymentStage('Done'))
                    dispatch(updatePayPeriod(payPeriodId, response))
                    NotificationManager.success('Successfully Sent Payments to Fyorin', 'Fyorin Sync Payroll')
                })
                .catch((error) => {
                    console.error(error)
                    dispatch(setPaymentStage('Error'))
                    NotificationManager.error('Failed to Send Payments', 'Fyorin Sync Payroll')
                })
        }

    }
}

const syncEmployees = (payPeriodId, transferDate) => {
    return async (dispatch, getState) => {
        let state = getState()
        const unsyncedEmployees = state?.integration?.payment?.fyorin?.unsyncedEmployees

        dispatch(setPaymentStage('Syncing'))

        await Promise.all(unsyncedEmployees.map(async (employee, index) => {
            // await new Promise((resolve, reject) => { //Fake Request For Demo
            //     setTimeout(() => { resolve() }, (index + 1)*1000);
            // })
            await updateEmployeeRequest(employee)
                .then(() => {
                    dispatch(updateSyncingState({ syncingStatus: (index + 1) / unsyncedEmployees?.length * 100 }))
                    console.log('syncemployees- success')
                })
                .catch(() => {
                    dispatch(updateSyncingState({ error: true }))
                    console.log('syncemployees- error')
                })
        }))


        dispatch(sendPayrollToFyorin(payPeriodId, transferDate))
    }
}

const Actions = {
    connectFyorin,
    disconnectFyorin,
    updateFyorinEmployee,
    verifyConnection,
    setPaymentStage,
    getEmployeesToSync,
    syncEmployees,
    getPayrollUpdate
}

export { Types, Actions }
